import { mkType, SchemaToType } from '@main/schema-utils';

export const ProcessingActivityPreview = mkType({
  name: 'ProcessingActivityPreview',
  comment: 'A preview of a processing activity',
  fields: {
    id: {
      comment: 'The unique ID of the processing activity',
      modelName: 'processingActivity',
      type: 'id',
    },
    title: {
      comment: 'The title of the processing activity',
      type: 'string',
    },
  },
});

/** Override type */
export type ProcessingActivityPreview = SchemaToType<
  typeof ProcessingActivityPreview
>;
